import { useRouter } from 'next/router'
import GConfirmButton from 'src/components/gButtons/gConfirmButton'
import { ButtonContainer, Container, SubtitleToLogin } from './styles'

const LoginToViewRegisteredZipcode = () => {
  const route = useRouter()

  const onClick = () => {
    route.push('/login')
  }

  return (
    <Container>
      <SubtitleToLogin>Selecione CEPs cadastrados</SubtitleToLogin>
      <ButtonContainer>
        <GConfirmButton onSubmit={onClick}>Fazer Login</GConfirmButton>
      </ButtonContainer>
    </Container>
  )
}

export default LoginToViewRegisteredZipcode
